// the default value of database current value
export var DATABASE_DEFAULT_CURRENT_VERSION = 0;
// the default value of user open database version
export var DATABASE_DEFAULT_OPEN_VERSION = 1;
//# sourceMappingURL=constant.js.map